export * from './my-registrations-page.component';
